import { render } from "./AddLessionUnit.vue?vue&type=template&id=489d6d4a&scoped=true"
import script from "./AddLessionUnit.vue?vue&type=script&lang=js"
export * from "./AddLessionUnit.vue?vue&type=script&lang=js"

import "./AddLessionUnit.vue?vue&type=style&index=0&id=489d6d4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-489d6d4a"]])

export default __exports__